document.querySelectorAll('.PDP_object_engineer_skin_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {

    // Scope every control lookup to this carousel.
    // A bare '.swiper-pagination' selector is document-wide, and a product page
    // also has one inside the product gallery's .swiper Product_media_slider,
    // earlier in the DOM. Left unscoped, this carousel's dots render under the
    // gallery images and drive a section thousands of pixels below.
    const pagination = el.querySelector('.swiper-pagination');
    const stopBtn    = el.querySelector('#stop_autoplay')  || document.getElementById('stop_autoplay');
    const startBtn   = el.querySelector('#start_autoplay') || document.getElementById('start_autoplay');

    const swiper = new Swiper(el, {
        /* The next card's media only started downloading once the swipe had already
           moved it into view, so you swiped and then watched it arrive. Preload the
           two cards either side instead, so the one you are swiping to is ready. */
        lazyPreloadPrevNext: 2,
        loop: false,
        // rewind is off. With free scrolling, rewind teleports the row back to
        // slide 1 the moment you push past the last card, which reads as the
        // carousel snatching itself away from you.
        rewind: false,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        // Small threshold so a short flick registers instead of being swallowed.
        threshold: 3,
        // Free scrolling with momentum. Without this, slidesPerView:'auto' snaps
        // to a card edge on every gesture and advances exactly one card, which is
        // what made the row feel hooked and stuck partway through.
        freeMode: {
          enabled: true,
          sticky: false,
          momentum: true,
          momentumRatio: 0.7,
          momentumVelocityRatio: 0.7,
          momentumBounce: false,
        },
        resistanceRatio: 0.6,
        // forceToAxis so only horizontal wheel/trackpad deltas move the row, and
        // releaseOnEdges so once the row is at either end the page scroll takes
        // over again. Both flags are required: an earlier build had forceToAxis
        // alone, which held onto the wheel at the ends and blocked page scroll.
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          thresholdDelta: 6,
        },
        touchReleaseOnEdges: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
        autoplay: {
            delay: 6000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
    })

    // This section is meant to be read, so it does not auto-advance.
    // Park it on slide 1 and offer play as an opt-in.
    swiper.autoplay?.stop();
    stopBtn?.classList.add('hidden');
    startBtn?.classList.remove('hidden');

    stopBtn?.addEventListener('click', () => {
        swiper.autoplay.stop();
        stopBtn.classList.add('hidden');
        startBtn?.classList.remove('hidden');
    });

    startBtn?.addEventListener('click', () => {
        swiper.autoplay.start();
        startBtn.classList.add('hidden');
        stopBtn?.classList.remove('hidden');
    });
  }
})
